import React from 'react';

const Logo = (props) => (
  <img alt="Logo" width={364} height={69} src="/static/logo.png" {...props} />
);

export default Logo;
